var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content warehouse-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "400px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { width: "100%" } },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-position": "left", "label-width": "80px" }
            },
            [
              _vm.type === "in"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.StorageDay") } },
                    [
                      _c("el-date-picker", {
                        ref: "arriveStorageDate",
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.inData.arriveStorageDate,
                          callback: function($$v) {
                            _vm.$set(_vm.inData, "arriveStorageDate", $$v)
                          },
                          expression: "inData.arriveStorageDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === "out"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.DeliveryDay") } },
                    [
                      _c("el-date-picker", {
                        ref: "deliverDate",
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.outData.deliverDate,
                          callback: function($$v) {
                            _vm.$set(_vm.outData, "deliverDate", $$v)
                          },
                          expression: "outData.deliverDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === "out"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.outData.deliverRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.outData, "deliverRemarks", $$v)
                          },
                          expression: "outData.deliverRemarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === "in"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.inData.arriveStorageRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.inData, "arriveStorageRemarks", $$v)
                          },
                          expression: "inData.arriveStorageRemarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }